import React, { Dispatch, SetStateAction } from "react";
import { FiDownload, FiFileText } from "react-icons/fi";

import FormModal from "@/components/Modal/FormModal";
import { moneyFormatterWithoutCurrency } from "@/utils/moneyFormat";
import { formatNumberWithCommas } from "@/utils/numberFormater";

export type DistributorBillItem = {
  id: number;
  facility_id: number;
  facility_code: string;
  distributor_name?: string;
  kwh?: number;
  total_price?: number;
  has_pdf: boolean;
  pdf_url?: string;
};

type Props = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  consumerName: string;
  referenceMonth: {
    month: string;
    year: string;
  };
  bills: DistributorBillItem[];
};

export default function DistributorBillsModal({
  isOpen,
  setIsOpen,
  consumerName,
  referenceMonth,
  bills,
}: Props) {
  function closeModal() {
    setIsOpen(false);
  }

  return (
    <FormModal
      isOpen={isOpen}
      onClose={closeModal}
      title="Contas de Luz - Distribuidora"
      description={`${consumerName} • ${referenceMonth.month}/${referenceMonth.year}`}
      footerDisabled={true}
      size="md"
    >
      <div className="flex flex-col gap-4">
        <p className="text-sm text-gray-600">
          Selecione a instalação (UC) para baixar a conta de luz correspondente:
        </p>

        <div className="flex flex-col gap-3">
          {bills && bills.length > 0 ? (
            bills.map((bill) => (
              <div
                key={bill.id || bill.facility_code}
                className="flex items-center justify-between rounded-2xl border border-gray-200 bg-gray-50 p-4 transition-all hover:bg-gray-100"
              >
                <div className="flex items-center gap-3">
                  <div className="flex size-10 items-center justify-center rounded-full bg-[#125247]/10 text-[#125247]">
                    <FiFileText size={20} />
                  </div>
                  <div>
                    <div className="flex items-center gap-2">
                      <span className="font-semibold text-gray-900">
                        UC: {bill.facility_code || "Sem código"}
                      </span>
                      {bill.distributor_name && (
                        <span className="rounded-full bg-emerald-100 px-2.5 py-0.5 text-xs font-medium text-emerald-800">
                          {bill.distributor_name}
                        </span>
                      )}
                    </div>
                    <div className="mt-1 text-xs text-gray-500">
                      {bill.kwh != null && <span>{formatNumberWithCommas(bill.kwh)} kWh</span>}
                      {bill.total_price != null && (
                        <span className="ml-2">
                          &bull; R$ {moneyFormatterWithoutCurrency(bill.total_price)}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div>
                  {bill.has_pdf && bill.pdf_url ? (
                    <a
                      href={bill.pdf_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-1.5 rounded-full bg-black px-4 py-2 text-xs font-bold text-white transition-opacity hover:opacity-90"
                    >
                      <FiDownload size={14} />
                      Baixar PDF
                    </a>
                  ) : (
                    <span className="rounded-full bg-gray-200 px-3 py-1.5 text-xs font-medium text-gray-500">
                      PDF indisponível
                    </span>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="py-6 text-center text-sm text-gray-500">
              Nenhuma conta da distribuidora encontrada para este mês.
            </div>
          )}
        </div>
      </div>
    </FormModal>
  );
}
